<template>
  <IQOS title="AR Меню" required>
      <p class="iqos-comment mt-16">   
          iOS URL:
      </p>
      <BaseInput 
        class="mt-8"
        fullWidth
        v-model="iosUrl"
        @blur="saveProduct"
        placeholder="https://mymodel.com/dish.usdz"
        />

    <p class="iqos-comment mt-16">   
          Android URL:
      </p>
      <BaseInput
        class="mt-8"
        fullWidth
        v-model="androidUrl"
        @blur="saveProduct"
        placeholder="https://mymodel.com/dish.gltf"
        />
  </IQOS>
</template>

<script>
export default {
    methods: {
        saveProduct() {
            this.$store.dispatch('menu/updateProduct');
        }
    },
    computed: {
        dish() {
            return this.$store.state.menu.product;
        },
        iosUrl: {
            get() {
                return this.dish.ar_ios_url;
            },
            set(value) {
                this.$store.commit("menu/setProductData", {
                    key: "ar_ios_url",
                    value,
                });
            }
        },
        androidUrl: {
            get() {
                return this.dish.ar_android_url;
            },
            set(value) {
                this.$store.commit("menu/setProductData", {
                    key: "ar_android_url",
                    value,
                });
            }
        }
    }
}
</script>

<style>

</style>